import { Button, DeleteIcon, Menu, MoreIcon, Space } from "melco-ui";
import { Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import { useConfirm } from "melco-shared-logic";
import { useNavigate } from "react-router";
import { isEmpty } from "lodash-es";
import { useDeleteMachineGroups } from "../../../hooks/reporting/useDeleteGroups";

type MachineGroupMoreActionButtonProps = {
  machineGroup: any;
};

export const MachineGroupMoreActionButton: React.FC<
  MachineGroupMoreActionButtonProps
> = ({ machineGroup }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const deleteMachineGroups = useDeleteMachineGroups();

  const confirmDelete = useConfirm(
    async () => {
      if (machineGroup.id) {
        const successfullyDeletedIds = await deleteMachineGroups([
          machineGroup.id,
        ]);

        // // redirect to list view in case the entity was deleted successfully
        if (!isEmpty(successfullyDeletedIds)) {
          navigate(`/reporting/machine/groups`);
        }
      }
    },
    {
      translationPrefix: "reporting.machinegroups.actions.delete",
      translationOptions: {
        count: 1,
      },
      content: (
        <Space direction="vertical" size="small">
          {t("reporting.machinegroups.actions.delete.confirmation.message_one")}
        
        </Space>
      ),
    }
  );

  const MoreActions = (
    <Menu>
      <Menu.Item
        key="more-actions-delete"
        onClick={() => {
          confirmDelete();
        }}
        danger
        icon={<DeleteIcon />}
        data-cy-id="delete-machine-group"
      >
        {t("reporting.machinegroups.actions.delete.button")}
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={MoreActions}
      trigger={["click"]}
      placement="bottomRight"
      arrow
    >
      <Button
        key="machine-group-more-actions"
        icon={<MoreIcon />}
        data-cy-id="machine-group-more-actions"
      />
    </Dropdown>
  );
};
